import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const ready = useAuthStore((s) => s.ready)
  const user = useAuthStore((s) => s.user)
  const init = useAuthStore((s) => s.init)
  const location = useLocation()

  useEffect(() => {
    if (!ready) void init()
  }, [ready, init])

  if (!ready) {
    return (
      <div className="min-h-dvh bg-background text-foreground">
        <div className="mx-auto max-w-6xl px-4 py-10">
          <div className="h-8 w-48 rounded bg-surface-alt animate-pulse" />
          <div className="mt-6 grid gap-3">
            <div className="h-24 rounded bg-surface-alt animate-pulse" />
            <div className="h-64 rounded bg-surface-alt animate-pulse" />
          </div>
        </div>
      </div>
    )
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?next=${next}`} replace />
  }

  if (user.cooperativeRoles?.length > 0) {
    return <Navigate to="/portal-cooperativa" replace />
  }

  // Senha temporária (`123456`) → força troca antes de liberar qualquer rota.
  // A própria tela de troca renderiza sem loop infinito (exceção da regra).
  if (user.passwordMustChange && location.pathname !== '/app/change-password') {
    return <Navigate to="/app/change-password" replace />
  }

  // PIN inicial do gerente (PWA) → escolher o PIN pessoal antes de qualquer tela.
  if (user.pinMustChange && location.pathname !== '/pin') {
    return <Navigate to="/pin" replace />
  }

  return <>{children}</>
}

